var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32009_1013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.41961C0 0.63558 0.635581 0 1.41961 0H18.5804C19.3645 0 20.0001 0.635581 20.0001 1.41961V18.5804C20.0001 19.3644 19.3645 20 18.5804 20H1.41961C0.635582 20 0 19.3644 0 18.5804V1.41961Z",
    fill: "#C6CBD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48891 6.21683C5.44712 6.21683 6.22391 5.44004 6.22391 4.48183C6.22391 3.52361 5.44712 2.74683 4.48891 2.74683C3.53069 2.74683 2.75391 3.52361 2.75391 4.48183C2.75391 5.44004 3.53069 6.21683 4.48891 6.21683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81287 7.49904H10.6883V8.8163C10.6883 8.8163 11.4686 7.25571 13.5917 7.25571C15.4856 7.25571 17.0544 8.18868 17.0544 11.0324V17.0291H14.0746V11.7591C14.0746 10.0815 13.179 9.89702 12.4966 9.89702C11.0802 9.89702 10.8378 11.1187 10.8378 11.9779V17.0291H7.81287V7.49904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.97646 7.49905H6.00135V17.0291H2.97646V7.49905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32009_1013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGrey);
export default __webpack_public_path__ + "static/media/linkedinGrey.00021263ef32748117123e9d027cdeb9.svg";
export { ForwardRef as ReactComponent };